import { simpleStringHash } from '@eventbrite/string-utils';
import has from 'lodash/has';
import omit from 'lodash/omit';
import some from 'lodash/some';
import values from 'lodash/values';
import { ENTITY_TYPE_MAP } from '../../../constants';
import {
    CITY_BROWSE_SECTION,
    ONLINE_BROWSE_SECTION,
} from '../../../constants/analytics';
import { BucketConfig, entities } from '../../../types/index';
import { CARD_INFO_LOOKUP_MAP } from '../../../utils/general';

/**
 * Should hide mask
 */
export const getMaskState = (
    {
        headerImageUrl,
        ...pageBrandInfo
    }: { headerImageUrl?: string; pageBrandInfo?: any },
    isOnline?: boolean,
) => {
    /* If we have no image at all, always show the gradient & mask */
    if (!headerImageUrl) {
        return false;
    }

    /* We always want to hide the mask for online */
    if (isOnline) {
        return true;
    }
    /* If any brand content has a truthy value besides headerImageUrl
    and headerSmallImageUrl hide the mask. */
    let result: any = omit(pageBrandInfo, [
        'artistSocialLinks',
        'headerSmallImageUrl',
    ]);

    result = values(result);
    result = some(result);

    return result;
};

export const getRandomAsset = (assetList: string[], hashTarget: string) =>
    //HACK Set as an explicit any as `simpleStringHash` returns a string, but has a mathematical operation applied to it
    assetList[(simpleStringHash(hashTarget) as any) % assetList.length];

export const getBucketContent = (
    { entities }: { entities: entities },
    bucketConfig: BucketConfig,
    currencyFormat: string,
    section: string,
) => {
    const { type, ...remainingBucketConfig } = bucketConfig;

    let content;

    if (has(ENTITY_TYPE_MAP, type)) {
        const entityKey = ENTITY_TYPE_MAP[type as string];

        if (remainingBucketConfig[entityKey]) {
            const bucketContent = remainingBucketConfig[entityKey].map(
                (id: string) => entities[id],
            );

            content = CARD_INFO_LOOKUP_MAP[type as string]({
                bucketsContent: bucketContent,
                currencyFormat,
                section,
            });
        }
    }

    return content;
};

export const getBrowseSection = (isOnlineBrowse: boolean) =>
    isOnlineBrowse ? ONLINE_BROWSE_SECTION : CITY_BROWSE_SECTION;
